import { QRZ_ERROR_CONFIGS } from "./QrzErrorConfigs";
import type { LookupServiceProviderType } from "@/types";

/**
 * Translates QRZ API error responses into standardized error types
 * @param providerName - The name of the provider (e.g., "QRZ")
 * @param errorMessage - The error message from the QRZ API
 * @throws {ProviderAuthenticationError | ProviderSessionExpiredError | ProviderCallsignNotFoundError | Error}
 */
export function handleQrzError(
  providerName: LookupServiceProviderType,
  errorMessage: string
): never {
  const trimmedError = errorMessage.trim();

  // Process error configurations and throw appropriate error
  for (const config of Object.values(QRZ_ERROR_CONFIGS)) {
    const match = trimmedError.match(config.pattern);
    if (match) {
      throw new config.error(providerName, config.generateMessage(match[1]));
    }
  }

  // For unknown errors, throw generic error
  throw new Error(`QRZ error: ${errorMessage}`);
} 